import React from 'react';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../Widget/ControllerContext';
import {getDirValue} from '../../../domain/utils/getDirValue';
import {Layout} from '../../../common/components/Layout/Layout';
import {Header} from '../Header/Header';
import {Footer} from '../Footer/Footer';
import {Summary} from '../Summary/Summary';
import {PaymentRequestViewLayout} from '../PaymentRequestViewLayout/PaymentRequestViewLayout';
import {PaymentRequestState} from '../../../types/paymentRequestApp.types';
import {PaymentFlow} from '../PaymentFlow/PaymentFlow';
import {pageTheme} from '../../../common/components/WithThemeOverride/pageTheme';
import {ErrorState} from '../../../common/components/Layout/ErrorState/ErrorState';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';

export enum PaymentRequestAppDataHook {
  root = 'PaymentRequestAppDataHook.root',
  footer = 'PaymentRequestAppDataHook.footer',
  header = 'PaymentRequestAppDataHook.header',
  summary = 'PaymentRequestAppDataHook.summary',
  policies = 'PaymentRequestAppDataHook.policies',
}

const PaymentRequestApp = () => {
  const {isLoading, isOneColumnView, paymentRequestState, paymentRequestStore, navigationStore, isPoliciesPage} =
    useControllerProps();
  const {isRTL, isMobile} = useEnvironment();
  const isUnpaid = paymentRequestState === undefined || paymentRequestState === PaymentRequestState.unpaid;
  const localeKeys = useLocaleKeys();

  if (isPoliciesPage) {
    return <div style={pageTheme} data-hook={PaymentRequestAppDataHook.policies} />;
  }
  return (
    <div style={pageTheme} className={isMobile ? 'mobile-view' : undefined}>
      <TPAComponentsProvider value={{rtl: isRTL}}>
        {isUnpaid || paymentRequestState === PaymentRequestState.error ? (
          <Layout
            dataHook={PaymentRequestAppDataHook.root}
            isLoading={isLoading}
            showErrorState={paymentRequestState === PaymentRequestState.error}
            isOneColumnView={isOneColumnView}
            dir={getDirValue(isRTL)}
            Header={() => <Header dataHook={PaymentRequestAppDataHook.header} />}
            Aside={() => <Summary dataHook={PaymentRequestAppDataHook.summary} />}
            ErrorState={() => (
              <ErrorState
                title={localeKeys.checkout.payLinks.generalError.title()}
                subtitle={navigationStore?.paymentRequestResolvedError}
                onClick={paymentRequestStore?.clickOnRefreshErrorState}
              />
            )}
            Footer={() => <Footer dataHook={PaymentRequestAppDataHook.footer} />}>
            {<PaymentFlow />}
          </Layout>
        ) : (
          <PaymentRequestViewLayout dir={getDirValue(isRTL)} isLoading={isLoading} />
        )}
      </TPAComponentsProvider>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default PaymentRequestApp;
